import { Loader } from '@thinknet-gmbh/platform-common-ui';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { toolbarPlugin, ToolbarSlot } from '@react-pdf-viewer/toolbar';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';

import { base64ToBlob } from './document-viewer.helpers';
import { DocumentWrapper, ToolbarWrapper, ElementWrapper } from './document-viewer.styles';
import { DOCUMENT_VIEWER_WORKER_URL } from './document-viewer.constants';

const DocumentViewer = ({ loading, base64 }: { loading: boolean; base64: string }) => {
  const toolbarInstance = toolbarPlugin();
  const { Toolbar } = toolbarInstance;

  if (loading) {
    return <Loader />;
  }

  const blob = base64ToBlob(base64);
  const url = URL.createObjectURL(blob);

  return (
    <Worker workerUrl={DOCUMENT_VIEWER_WORKER_URL}>
      <Toolbar>
        {({
          GoToPreviousPage,
          CurrentPageInput,
          NumberOfPages,
          ZoomIn,
          ZoomOut,
          Zoom,
          EnterFullScreen,
          Download,
          Print,
          GoToNextPage,
        }: ToolbarSlot) => (
          <ToolbarWrapper>
            <ElementWrapper>
              <GoToPreviousPage />
              <CurrentPageInput />
              / <NumberOfPages />
              <GoToNextPage />
            </ElementWrapper>
            <ElementWrapper>
              <ZoomOut />
              <Zoom />
              <ZoomIn />
            </ElementWrapper>
            <ElementWrapper>
              <EnterFullScreen />
              <Download />
              <Print />
            </ElementWrapper>
          </ToolbarWrapper>
        )}
      </Toolbar>
      <DocumentWrapper>
        <Viewer fileUrl={url} plugins={[toolbarInstance]} />
      </DocumentWrapper>
    </Worker>
  );
};

export default DocumentViewer;
